import { useMetadata } from "@/hooks/useMetadata";
import type { PropsWithChildren } from "react";

/**
 * MetadataProvider component
 * Automatically applies metadata when route changes
 * Should be placed inside BrowserRouter
 */
export function MetadataProvider({ children }: PropsWithChildren) {
  useMetadata();
  return <>{children}</>;
}
